import axios from 'axios'
import { ref } from 'vue'

export function useTickets({
    onDeleted = () => {},
    onError = () => {},
}) {
    const deleting = ref(false)

    const deleteTicket = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/tickets/${id}`)
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteTicket,
    }
}
